module.exports = __webpack_public_path__ + "static/media/speech_01.eeac0d17.svg";